<template>
  <div>
    <table border="1" cellspacing="0">
      <tr class="tr1">
        <th></th>
        <th>近1周</th>
        <th>近1月</th>
        <th>近3月</th>
        <th>近6月</th>
        <th>今年来</th>
        <th>近1年</th>
        <th>近2年</th>
        <th>近3年</th>
      </tr>
      <tr class="tr2">
        <td>阶段涨幅</td>
        <td
          v-for="(item, index) in tableData[0]"
          :key="'1' + index"
          :class="{ color_red: item > 0, color_green: item < 0 }"
        >
          {{ item }}%
        </td>
      </tr>
      <tr class="tr2">
        <td>同类平均</td>
        <td
          v-for="(item, index) in tableData[1]"
          :key="'1' + index"
          :class="{ color_red: item > 0, color_green: item < 0 }"
        >
          {{ item }}%
        </td>
      </tr>
      <tr class="tr2">
        <td>沪深300</td>
        <td
          v-for="(item, index) in tableData[2]"
          :key="'1' + index"
          :class="{ color_red: item > 0, color_green: item < 0 }"
        >
          {{ item }}%
        </td>
      </tr>
      <tr class="tr3">
        <td>同类排名</td>
        <td v-for="(item, index) in tableData[3]" :key="'1' + index">
          {{ item }}
        </td>
      </tr>
      <tr class="tr4">
        <td>同类排名</td>
        <td v-for="(item, index) in tableData[4]" :key="'1' + index">
          <div class="bg1" :class="{ bg0: item != 4 }"></div>
          <div class="bg2" :class="{ bg0: item < 3 }"></div>
          <div class="bg3" :class="{ bg0: item < 2 }"></div>
          <div class="bg4" :class="{ bg0: item < 1 }"></div>
          <div
            v-if="item == 4"
            style="text-align: center; font-size: 12px; color: #666"
          >
            优秀
          </div>
          <div
            v-if="item == 3"
            style="text-align: center; font-size: 12px; color: #666"
          >
            良好
          </div>
          <div
            v-if="item == 2"
            style="text-align: center; font-size: 12px; color: #666"
          >
            一般
          </div>
          <div
            v-if="item == 1"
            style="text-align: center; font-size: 12px; color: #666"
          >
            不佳
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        [
          "-0.06",
          "-2.78",
          "-18.59",
          "-17.15",
          "-15.33",
          "-28.63",
          "15.01",
          "65.98",
        ],
        [
          "0.14",
          "-2.78",
          "-18.59",
          "-17.15",
          "-15.33",
          "-28.63",
          "15.01",
          "65.98",
        ],
        [
          "0.14",
          "-2.78",
          "-18.59",
          "-17.15",
          "-15.33",
          "-28.63",
          "15.01",
          "65.98",
        ],
        [
          "5691/5827",
          "5197/5908",
          "5164/5862",
          "5534/5701",
          "4666/5278",
          "4245/4422",
          "2600/3167",
          "1297/2733",
        ],
        ["3", "1", "2", "1", "1", "1", "1", "4"],
      ],
    };
  },
};
</script>

<style scoped>
.tr1 th {
  width: 160px;
  height: 56px;
  background-color: #f8f9fd;
  font-size: 16px;
  font-weight: normal;
  color: #333333;
}
table {
  border-color: #e9ebf3;
  border-collapse: collapse;
}
.color_red {
  color: #fd4c4c;
}
.color_green {
  color: #47ba74;
}
.tr2 td {
  width: 162px;
  height: 56px;
  background-color: #ffffff;
  text-align: center;
}
.tr3 td {
  width: 162px;
  height: 56px;
  background-color: #ffffff;
  text-align: center;
  color: #333;
}
.tr4 td {
  width: 162px;
  height: 96px;
  text-align: center;
  background-color: #ffffff;
}

.bg1 {
  width: 48px;
  height: 16px;
  background-color: #9bbee9;
  margin: 0 auto;
  border: solid 1px #e9ebf3;
  border-collapse: collapse;
  
}
.bg2 {
  width: 48px;
  height: 16px;
  background-color: #b3ceef;
  margin: 0 auto;
  border: solid 1px #e9ebf3;
  border-collapse: collapse;
  border-top: none;
}
.bg3 {
  width: 48px;
  height: 16px;
  background-color: #cbdff8;
  margin: 0 auto;
  border: solid 1px #e9ebf3;
  border-collapse: collapse;
  border-top: none;
}
.bg4 {
  width: 48px;
  height: 16px;
  background-color: #e1edfc;
  margin: 0 auto;
  border: solid 1px #e9ebf3;
  border-collapse: collapse;
  border-top: none;
}
.bg0 {
  background-color: transparent;
}
</style>